// extracted by mini-css-extract-plugin
module.exports = {"reference":"TransferListColumnMovileView_reference__PGANZ","actionsContent":"TransferListColumnMovileView_actionsContent__Qh93C"};